import { ref, computed, onMounted, watch, nextTick } from "vue"
import { useStore } from "vuex"
import GroupCard from "../GroupCard/GroupCard.vue"
import SpotCardGrid from "../SpotCardGrid/SpotCardGrid.vue"
import GetLabel from "foundation/js/getLabel"

export default {
    name: "GroupSearchResult",
    components: {
        GroupCard,
        SpotCardGrid
    },
    props: {
        source: {
            type: String,
            required: false
        },
        hovedgruppekode: {
            type: String,
            required: false
        },
        guid: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            required: true,
            default: 0
        },
        take: {
            type: Number,
            required: true,
            default: 10
        },
        spotCard: {
            type: Object,
            required: false
        },
        disableInitialSearch: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    setup(props) {
        const store = useStore() 

        onMounted(() => {
            initFetchGroups()
        })

        const url = computed(() => {
            switch (props.source) {
                case 'frivillig-all':
                    return process.env.FRIVILLIGE_GROUPS_SEARCH
                        .replace('[pageId]', store.state.main.page_id)
                case 'frivillig-hovedgruppe':
                    return process.env.FRIVILLIGE_GROUPS_HOVEDGRUPPE_SEARCH
                        .replace('[pageId]', store.state.main.page_id)
                        .replace('[hovedgruppekode]', props.hovedgruppekode)
                default:
                    return process.env.GET_GROUP_SEARCH_RESULT
            }
        })
        
        const resultFocusIndex = ref(0)
        const isNotCancerforum = props.source != 'cancerforum'
        const totalAmount = computed(() => store.state.search.scoped_total[props.guid] ?? 0)
        const searchQuery = computed(() => store.state.search.queries[props.guid] ?? '')
        const results = computed(() => store.state.search.results[props.guid] ?? [])
        const tags = computed(() => store.getters['search/selectedTags'](props.guid) ?? [])
        const showSpinner = computed(() => store.state.search.search_inprogress[props.guid])
        const showResults = computed(() => store.state.search.show_results[props.guid])
        const resultCount = computed(() => results.value.length)

        const displaySearchResults = computed(() => showResults.value && (isNotCancerforum || searchQuery.value.length > 0))

        const initFetchGroups = () => {
            store.commit('search/set_replaceQueryInUrl', false)

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: url.value
            })

            if(props.disableInitialSearch !== true) {
                store.dispatch('search/performSearch', {
                    guid: props.guid,
                    query: '',
                    skip: props.skip,
                    take: props.take
                })
            }
        }

        watch(results, async (newResults, _) => {
            if (resultFocusIndex.value === 0) {
                return
            }

            const newestResult = newResults[resultFocusIndex.value]
            await nextTick()
            const resultToFocus = document.getElementById(newestResult.id)
            resultToFocus.focus()
        })

        const getMoreResults = async (isKeydownEvent = false) => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
           
            if (isKeydownEvent) {
                // If the getMoreResults button was pressed using the enter key, we update the index keeping track of the result to focus
                resultFocusIndex.value = results.value.length
            }
        }

        return {
            isNotCancerforum,
            totalAmount,
            searchQuery,
            results,
            tags,
            showSpinner,
            showResults,
            resultCount,
            displaySearchResults,
            getMoreResults,
            getLabel: (labelKey, params) => GetLabel({ labelKey, labelCollection: 'GroupSearchResult', params })
        }
    }   
}